import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";
import { Divider } from '../components/Divider';

import cover from "../assets/img/genai1.webp";
import { Container } from 'react-bootstrap';


export const projectDetails: ProjectInterface = {
    url: "genart",
    title: "Creative Coding",
    summary: "A collection of some algorithmic art I've created.",
    description: ``,
    year: "",
    tags: ["Code Art", "Web", "P5.js"],
    imageSrc: cover,
    hasVideo: false,
    startVideoTime: 0,
    videoSrc: "",
    isCoverType: true,
    haveTags: false,
    projectType: ProjectType.SIDE,
    roles: ["Programmer", "Hobby"],
    technologies: ["Web", "Processing", "P5.js"],
    collaborators: ["Lucas Coutinho"],
    highlightColor: "#60151F",
    descriptionTitle: "",
    linkData:
        [
        ]
};


export function GenArt() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={false}
                leftContent={
                    <div className="a-left-no-bg">
                    </div>
                }
                rightContent={
                    <div className="a-right-no-bg">
                    </div>
                }>

                <Container className="a-body">
                    <Divider width={100} />
                </Container>
            </ProjectBase>
        </div>
    );
}